import { APIPath } from '@intigral/constant';
import { ApiConfig } from '../../core/entities/ApiConfig';
import { Placeholder } from '../../core/entities/CmsConfig';

/** Persona service base URL; falls back from profiles/entitlement env when not set explicitly. */
const resolvePersonaBaseUrl = (): string => {
    const personaBase = process.env['NX_PUBLIC_PERSONA_BASE_URL'];
    if (personaBase) {
        return personaBase.replace(/\/+$/, '');
    }

    const profileBase = process.env['NX_PUBLIC_PROFILE_BASE_URL'] || '';
    if (profileBase) {
        return profileBase.replace(/\/profiles\/?$/, '/persona');
    }

    const entitlementBase = process.env['NX_PUBLIC_ENTITLEMENT_API_BASE_URL'] || '';
    if (entitlementBase) {
        return `${entitlementBase.replace(/\/+$/, '')}/persona`;
    }

    return 'https://micro-stg-api.intigral-ott.net/persona';
};

const personaBaseUrl = resolvePersonaBaseUrl();

const apis: ApiConfig[] = [
    // Your API configurations here
    {
        id: 'SERIES_HISTORY',
        type: 'VOD',
        feedType: 'SERIES_HISTORY',
        url: '${NX_PUBLIC_CAROUSEL_API_BASE_URL}' + APIPath.SERIES_HISTORY,
    },
    {
        id: 'PROFILE_DELETE',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_DELETE,
    },
    {
        id: 'USER_CDN_API_USER_REVISION',
        type: 'CDN',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_USER_CDN_API_BASE_URL}' + APIPath.USER_CDN_API_USER_REVISION,
    },
    {
        id: 'CONFIG_PAYMENT_CONFIG',
        type: 'PAYMENT',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_MLP_BFF_INTERNAL_BASE_URL}' + APIPath.CONFIG_PAYMENT_CONFIG,
    },
    {
        id: 'USER_CHANGE_PASSWORD',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_CHANGE_PASSWORD,
    },
    {
        id: 'USER_LOGIN_CREDENTIALS',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_LOGIN_CREDENTIALS,
    },
    {
        id: 'USER_LOCATE_USER',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_LOCATE_USER,
    },
    {
        id: 'USER_EMAIL_VERIFICATION_GENERATE_PIN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_EMAIL_VERIFICATION_GENERATE_PIN,
    },
    {
        id: 'USER_EMAIL_VERIFICATION_VERIFY_PIN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_EMAIL_VERIFICATION_VERIFY_PIN,
    },
    {
        id: 'USER_LOGIN_OTP',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_LOGIN_OTP,
    },
    {
        id: 'USER_LOGIN_STEP_1',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_LOGIN_STEP_1,
    },
    {
        id: 'USER_LOGIN_WITH_TOKEN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_LOGIN_WITH_TOKEN,
    },
    {
        id: 'USER_GENERATE_PIN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_GENERATE_PIN,
    },
    {
        id: 'USER_VERIFY_PIN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_VERIFY_PIN,
    },
    {
        id: 'USER_RESET_PASSWORD_STEP1',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_RESET_PASSWORD_STEP1,
    },
    {
        id: 'USER_RESET_PASSWORD_STEP2',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_RESET_PASSWORD_STEP2,
    },
    {
        id: 'USER_GENERATE_PIN_AUTHENTICATED_USER',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_GENERATE_PIN_AUTHENTICATED_USER,
    },
    {
        id: 'USER_VERIFY_PIN_AUTHENITCATED_USER',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_VERIFY_PIN_AUTHENITCATED_USER,
    },
    {
        id: 'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_EMAIL',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_FORGOT_PASSWORD_GENERATE_PIN_BY_EMAIL,
    },
    {
        id: 'USER_FORGOT_PASSWORD_VERIFIY_BY_EMAIL',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_FORGOT_PASSWORD_VERIFIY_BY_EMAIL,
    },
    {
        id: 'USER_FORGOT_PASSWORD_UPDATE_BY_EMAIL',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_FORGOT_PASSWORD_UPDATE_BY_EMAIL,
    },
    {
        id: 'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN,
    },
    {
        id: 'USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN,
    },
    {
        id: 'USER_FORGOT_PASSWORD_UPDATE_BY_MSISDN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_FORGOT_PASSWORD_UPDATE_BY_MSISDN,
    },
    {
        id: 'USER_SUBSCRIPTION_STATUS',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_SUBSCRIPTION_STATUS,
    },
    {
        id: 'USER_SUBSCRIPTION_STATUS_NEW',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_USER_IDENTITY_API_BASE_URL}' + APIPath.USER_SUBSCRIPTION_STATUS_NEW,
    },
    {
        id: 'USER_UNSUBSCRIBE',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_UNSUBSCRIBE,
    },
    {
        id: 'USER_TPAY_REDIRECT_SUBSCRIBE_NEW_USER',
        type: 'USER_SUBSCRIPTION',
        feedType: 'USER_SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_TPAY_REDIRECT_SUBSCRIBE_NEW_USER,
    },
    {
        id: 'USER_TPAY_REDIRECT_SUBSCRIBE_EXISTING_USER',
        type: 'USER_SUBSCRIPTION',
        feedType: 'USER_SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_TPAY_REDIRECT_SUBSCRIBE_EXISTING_USER,
    },
    {
        id: 'USER_PARTNER_ACTIVATE_LINK',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_PARTNER_ACTIVATE_LINK,
    },
    {
        id: 'USER_VERIFY_USER',
        type: 'CHANNEL',
        feedType: 'CHANNEL',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.USER_VERIFY_USER,
    },
    {
        id: 'VERIFY_EMAIL',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.VERIFY_EMAIL,
    },
    {
        id: 'CONTENT_CHANNELS_MINI_EPG',
        type: 'CHANNEL',
        feedType: 'CHANNEL',
        url: '${NX_PUBLIC_CHANNEL_CONTENT_CDN_BASE_URL}' + APIPath.CONTENT_CHANNELS_MINI_EPG,
    },
    {
        id: 'CONTENT_CHANNELS_ARRIS_STB',
        type: 'CHANNEL',
        feedType: 'CHANNEL',
        url: '${NX_PUBLIC_CHANNEL_CONTENT_CDN_BASE_URL}' + APIPath.CONTENT_CHANNELS_ARRIS_STB,
    },
    {
        id: 'CHANNELS',
        type: 'CHANNEL',
        feedType: 'CHANNEL',
        url: '${NX_PUBLIC_CHANNEL_CONTENT_CDN_BASE_URL}' + APIPath.CONTENT_CHANNELS,
    },
    //  {
    //     id: 'CHANNELS',
    //     type: 'CHANNEL',
    //     feedType: 'CHANNEL',
    //     url: '${NX_PUBLIC_BOLT_API_BASE_URL}' + APIPath.CONTENT_CHANNELS,
    // },
    {
        id: 'CONTENT_CHANNELS',
        type: 'CHANNEL',
        feedType: 'CHANNEL',
        url: '${NX_PUBLIC_CHANNEL_CONTENT_CDN_BASE_URL}' + APIPath.CONTENT_CHANNELS,
    },
    {
        id: 'CONTENT_CHANNELS_CDN_SCHEDULE',
        type: 'CDN',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_CHANNEL_CONTENT_CDN_BASE_URL}' + APIPath.CONTENT_CHANNELS_CDN_SCHEDULE,
    },
    {
        id: 'DEVICE_ADD',
        type: 'DEVICE',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_DEVICE_API_BASE_URL}' + APIPath.DEVICE_ADD,
    },
    {
        id: 'DEVICE_DELETE',
        type: 'DEVICE',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_DEVICE_API_BASE_URL}' + APIPath.DEVICE_DELETE,
    },
    {
        id: 'QR_GENERATE_CODE',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.QR_GENERATE_CODE,
    },
    {
        id: 'QR_AUTHENTICATE_CODE',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.QR_AUTHENTICATE_CODE,
    },
    {
        id: 'QR_CODE_LOGIN',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.QR_CODE_LOGIN,
    },
    {
        id: 'QR_CODE_PAIRING',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.QR_CODE_PAIRING,
    },
    {
        id: 'QR_CODE_LINK',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.QR_CODE_LINK,
    },
    {
        id: 'ENTITLEMENT_QITAF_GENERATE_OTP',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_QITAF_GENERATE_OTP,
    },
    {
        id: 'ENTITLEMENT_QITAF_TVOD_GENERATE_OTP',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_QITAF_TVOD_GENERATE_OTP,
    },
    {
        id: 'ENTITLEMENT_QITAF_VERIFY_OTP',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_QITAF_VERIFY_OTP,
    },
    {
        id: 'ENTITLEMENT_QITAF_TVOD_VERIFY_OTP',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_QITAF_TVOD_VERIFY_OTP,
    },
    {
        id: 'ENTITLEMENT_ALLOWED_COUNTRIES',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_ALLOWED_COUNTRIES,
    },
    {
        id: 'ENTITLEMENT_AVAILABLE_PACKAGES',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_AVAILABLE_PACKAGES,
    },
    {
        id: 'ENTITLEMENT_TVODS',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_TVODS,
    },
    {
        id: 'ENTITLEMENT_TVOD_PRICING_TEMPLATE',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_TVOD_PRICING_TEMPLATE,
    },
    {
        id: 'ENTITLEMENT_ALL',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_ALL,
    },
    {
        id: 'ENTITLEMENT_ALL_SUBSCRIPTION_TIERS',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_ALL_SUBSCRIPTION_TIERS,
    },
    {
        id: 'ENTITLEMENT_ALL_SUBSCRIPTION_TIERS_V2',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_ALL_SUBSCRIPTION_TIERS_V2,
    },
    {
        id: 'ENTITLEMENT_CHANNELS',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_CHANNELS,
    },
    {
        id: 'ENTITLEMENT_PROFILE_EPG_CHANNELS',
        type: 'CDENTITLEMENTN',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_PROFILE_EPG_CHANNELS,
    },
    {
        id: 'ENTITLEMENT_SUBSCRIBE',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_SUBSCRIBE,
    },
    {
        id: 'ENTITLEMENT_TVOD_PURCHASE',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_TVOD_PURCHASE,
    },
    {
        id: 'ENTITLEMENT_TVOD_OTP_GENERATE',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_TVOD_OTP_GENERATE,
    },
    {
        id: 'ENTITLEMENT_TVOD_OTP_VERIFY',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.ENTITLEMENT_TVOD_OTP_VERIFY,
    },
    {
        id: 'ENTITLEMENT_PAYMENT_SWITCH_GENERATE_PIN',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ENTITLEMENT_PAYMENT_SWITCH_GENERATE_PIN,
    },
    {
        id: 'ENTITLEMENT_PAYMENT_SWITCH_VERIFY_PIN',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ENTITLEMENT_PAYMENT_SWITCH_VERIFY_PIN,
    },
    {
        id: 'ENTITLEMENT_NETFLIX_FORGOT_ACCOUNT',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ENTITLEMENT_NETFLIX_FORGOT_ACCOUNT,
    },
    {
        id: 'ENTITLEMENT_AMAZON_ACTIVTION_LINK',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ENTITLEMENT_AMAZON_ACTIVTION_LINK,
    },
    {
        id: 'ENTITLEMENT_AMAZON_ACCOUNT_RECOVERY',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ENTITLEMENT_AMAZON_ACCOUNT_RECOVERY,
    },
    {
        id: 'MPX_ALL_VOD_FEED',
        type: 'MPX',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_MPX_PRODUCT_FEED_BASE_URL}' + APIPath.MPX_ALL_VOD_FEED,
    },
    {
        id: 'PROFILE_CUD',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_CUD,
    },
    {
        id: 'PROFILE_LIST',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_LIST,
    },
    {
        id: 'PROFILE_SWITCH',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_SWITCH,
    },
    {
        id: 'PROFILE_UPDATE',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.PROFILE_UPDATE,
    },
    {
        id: 'PROFILE_ADD',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.PROFILE_ADD,
    },
    {
        id: 'PROFILE_FAVORITE',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_FAVORITE,
    },
    {
        id: 'PROFILE_WATCHLIST',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_WATCHLIST,
    },
    {
        id: 'PROFILE_WATCHLIST_VOD',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_WATCHLIST_VOD,
    },
    {
        id: 'PROFILE_WATCHLIST_LINEAR',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_WATCHLIST_LINEAR,
    },

    {
        id: 'PROFILE_GET_WATCHLIST',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_GET_WATCHLIST,
    },

    {
        id: 'PROFILE_CREATE_PARENTAL_PIN',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_CREATE_PARENTAL_PIN,
    },
    {
        id: 'create_parental_lock_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_CREATE_PARENTAL_PIN,
    },
    {
        id: 'PROFILE_VALIDATE_PARENTAL_PIN',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_VALIDATE_PARENTAL_PIN,
    },
    {
        id: 'validate_parental_lock_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_VALIDATE_PARENTAL_PIN,
    },
    {
        id: 'PROFILE_GET_PARENTAL_PIN',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_GET_PARENTAL_PIN,
    },
    {
        id: 'PROFILE_UPDATE_PARENTAL_PIN',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_UPDATE_PARENTAL_PIN,
    },
    {
        id: 'PROFILE_RESET_PARENTAL_PIN_OTP',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_RESET_PARENTAL_PIN_OTP,
    },
    {
        id: 'PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY,
    },
    {
        id: 'reset_parental_lock_otp_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_RESET_PARENTAL_PIN_OTP,
    },
    {
        id: 'reset_parental_lock_otp_verify_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY,
    },
    {
        id: 'reset_parental_lock_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.PROFILE_UPDATE_PARENTAL_PIN,
    },
    {
        id: 'PROFILE_RESET_PARENTAL_PIN_WITH_OTP',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_RESET_PARENTAL_PIN_WITH_OTP,
    },
    {
        id: 'reset_parental_lock_with_otp_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_PERSONA_BASE_URL}' + APIPath.PROFILE_RESET_PARENTAL_PIN_WITH_OTP,
    },
    {
        id: 'PROFILE_VALIDATE_PASSWORD',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: '${NX_PUBLIC_BOLT_API_BASE_URL}' + APIPath.PROFILE_VALIDATE_PASSWORD,
    },
    {
        id: 'INTERNAL_VERIFY_USER',
        type: 'CDN',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.INTERNAL_VERIFY_USER,
    },
    {
        id: 'ZENDESK_SUBMIT_FORM',
        type: 'ZENDESK',
        feedType: 'ZENDESK',
        url: '${NX_PUBLIC_ZENDESK_BASE_URL}' + APIPath.ZENDESK_SUBMIT_FORM,
    },
    {
        id: 'CMS_CONFIGURATION',
        type: 'CMS',
        feedType: 'CMS',
        url: '${NX_CMS_API_BASE_URL}' + APIPath.CMS_CONFIGURATION,
    },
    {
        id: 'CMS_LANGUAGE',
        type: 'CMS',
        feedType: 'CMS',
        url: '${NX_CMS_API_BASE_URL}' + APIPath.CMS_LANGUAGE,
    },
    {
        id: 'CMS_SCREEN',
        type: 'CMS',
        feedType: 'CMS',
        url: '${NX_CMS_API_BASE_URL}' + APIPath.CMS_SCREEN,
    },
    {
        id: 'SLP_API_FORM_SIGNATURE',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_FORM_SIGNATURE,
    },
    {
        id: 'SLP_API_LOGIN_VERIFY',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_LOGIN_VERIFY,
    },
    {
        id: 'SLP_API_LOGIN_CREDENTIALS',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_LOGIN_CREDENTIALS,
    },
    {
        id: 'SLP_API_LOGIN_OTP',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_LOGIN_OTP,
    },
    {
        id: 'ENTITLEMENT_ADDON_PURCHASE',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ENTITLEMENT_ADDON_PURCHASE,
    },
    {
        id: 'SLP_API_FORGOT_PASSWORD_SEND_OTP',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_FORGOT_PASSWORD_SEND_OTP,
    },
    {
        id: 'SLP_API_FORGOT_PASSWORD_RESEND_OTP',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_FORGOT_PASSWORD_RESEND_OTP,
    },
    {
        id: 'SLP_API_FORGOT_PASSWORD_VERIFY_OTP',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_FORGOT_PASSWORD_VERIFY_OTP,
    },
    {
        id: 'SLP_API_FORGOT_PASSWORD_RESET',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_FORGOT_PASSWORD_RESET,
    },
    {
        id: 'POPCORN_API_FORGOT_PIN',
        type: 'POPCORN',
        feedType: 'POPCORN',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.POPCORN_API_FORGOT_PIN,
    },
    {
        id: 'SLP_API_VERIFY_QR_CODE',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_VERIFY_QR_CODE,
    },
    {
        id: 'AUTO_LOGIN',
        type: 'AUTH',
        feedType: 'AUTH',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.AUTO_LOGIN,
    },
    {
        id: 'LOGOUT_API',
        type: 'AUTH',
        feedType: 'AUTH',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.LOGOUT_API,
    },
    {
        id: 'AUTH_REFRESH_TOKEN',
        type: 'AUTH',
        feedType: 'AUTH',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.AUTH_REFRESH_TOKEN,
    },
    {
        id: 'REMINDER_API_SET_REMINDER',
        type: 'CDN',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_REMINDER_API_BASE_URL}' + APIPath.REMINDER_API_SET_REMINDER,
    },
    {
        id: 'REMINDER_API_UNSET_REMINDER',
        type: 'REMINDER',
        feedType: 'REMINDER',
        url: '${NX_PUBLIC_REMINDER_API_BASE_URL}' + APIPath.REMINDER_API_UNSET_REMINDER,
    },
    {
        id: 'REMINDER_API_LIST_REMINDER',
        type: 'REMINDER',
        feedType: 'REMINDER',
        url: '${NX_PUBLIC_REMINDER_API_BASE_URL}' + APIPath.REMINDER_VOD_API_LIST_REMINDER,
    },
    {
        id: 'REMINDER_LIST',
        type: 'REMINDER',
        feedType: 'REMINDER',
        url: '${NX_PUBLIC_REMINDER_API_BASE_URL}' + APIPath.REMINDER_VOD_API_LIST_REMINDER,
    },
    {
        id: 'SLP_API_AMAZON_ACTIVATE',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_API_AMAZON_ACTIVATE,
    },
    {
        id: 'ZENDESK_JWT_TOKEN',
        type: 'AUTH',
        feedType: 'AUTH',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ZENDESK_JWT_TOKEN,
    },
    {
        id: 'ZENDESK_JWT_TOKEN_CLASSIC',
        type: 'AUTH',
        feedType: 'AUTH',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ZENDESK_JWT_TOKEN_CLASSIC,
    },
    {
        id: 'DEVICE_PAIRING',
        type: 'AUTH',
        feedType: 'AUTH',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.DEVICE_PAIRING,
    },
    {
        id: 'BOOKMARK_API',
        type: 'BOOKMARK',
        feedType: 'BOOKMARK',
        url: '${NX_PUBLIC_BOOKMARK_API_BASE_URL}' + APIPath.BOOKMARK_API,
    },
    {
        id: 'BOOKMARK_API_DETAIL',
        type: 'BOOKMARK',
        feedType: 'BOOKMARK',
        url: '${NX_PUBLIC_BOOKMARK_API_BASE_URL}' + APIPath.BOOKMARK_API_DETAIL,
    },
    {
        id: 'GEO_LOCATION_API_GET_MY_LOCATION',
        type: 'GEOLOCATION',
        feedType: 'GEOLOCATION',
        url: '${NX_PUBLIC_GEO_LOCATION_API_BASE_URL}' + APIPath.GEO_LOCATION_API_GET_MY_LOCATION,
    },
    {
        id: 'USER_CONSENT_API',
        type: 'USER_CONSENT_REGISTRATION',
        feedType: 'USER_CONSENT_REGISTRATION',
        url: '${NX_PUBLIC_USER_REGISTRATION_API_BASE_URL}' + APIPath.USER_CONSENT_API,
    },
    {
        id: 'POPCORN_API_GET_ALL_PROMOTIONS',
        type: 'POPCORN',
        feedType: 'POPCORN',
        url: '${NX_PUBLIC_POPCORN_API_BASE_URL}' + APIPath.POPCORN_API_GET_ALL_PROMOTIONS,
    },
    {
        id: 'POPCORN_API_GET_ALL_REWIND',
        type: 'POPCORN',
        feedType: 'POPCORN',
        url: '${NX_PUBLIC_POPCORN_API_BASE_URL}' + APIPath.POPCORN_API_GET_ALL_REWIND,
    },
    {
        id: 'DISCOUNT_API_VALIDATE_GIFT_CARD',
        type: 'GIFT_CARD',
        feedType: 'GIFT_CARD',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.DISCOUNT_API_VALIDATE_GIFT_CARD,
    },
    {
        id: 'DISCOUNT_API_SUBSCRIBE_BY_GIFT_CARD',
        type: 'GIFT_CARD',
        feedType: 'GIFT_CARD',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.DISCOUNT_API_SUBSCRIBE_BY_GIFT_CARD,
    },
    {
        id: 'DISCOUNT_API_RESUBSCRIBE_BY_GIFT_CARD',
        type: 'GIFT_CARD',
        feedType: 'GIFT_CARD',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.DISCOUNT_API_RESUBSCRIBE_BY_GIFT_CARD,
    },
    {
        id: 'DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE',
        type: 'GIFT_CARD',
        feedType: 'GIFT_CARD',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE,
    },
    {
        id: 'DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE_VERIFY',
        type: 'GIFT_CARD',
        feedType: 'GIFT_CARD',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE_VERIFY,
    },
    {
        id: 'CHANNELS_HISTORY',
        type: 'CHANNELS',
        feedType: 'CHANNELS',
        url: '${NX_PUBLIC_CAROUSEL_API_BASE_URL}' + APIPath.CHANNELS_HISTORY,
    },
    {
        id: 'PROFILE_WATCH_HISTORY',
        type: 'VIEWERSHIP',
        feedType: 'VIEWERSHIP',
        url: '${NX_PUBLIC_CAROUSEL_API_BASE_URL}' + APIPath.PROFILE_WATCH_HISTORY,
    },
    {
        id: 'THINK_ANALYTICS_API_GET_VOD_LIST',
        type: 'THINK_ANALYTICS',
        feedType: 'THINK_ANALYTICS',
        url: '${NX_PUBLIC_THINK_ANALYTICS_API_BASE_URL}' + APIPath.THINK_ANALYTICS_API_GET_VOD_LIST,
    },
    {
        id: 'GATEWAY_CONFIGURATION',
        type: 'GATEWAY',
        feedType: 'GATEWAY',
        url: '${NX_PUBLIC_GATEWAY_API_BASE_URL}' + APIPath.GATEWAY_CONFIGURATION,
    },
    {
        id: 'GATEWAY_LANGUAGE',
        type: 'GATEWAY',
        feedType: 'GATEWAY',
        url: '${NX_PUBLIC_GATEWAY_API_BASE_URL}' + APIPath.GATEWAY_LANGUAGE,
    },
    {
        id: 'GATEWAY_SCREEN',
        type: 'GATEWAY',
        feedType: 'GATEWAY',
        url: '${NX_PUBLIC_GATEWAY_API_BASE_URL}' + APIPath.GATEWAY_SCREEN,
    },
    {
        id: 'THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED',
        type: 'THINK_ANALYTICS',
        feedType: 'THINK_ANALYTICS',
        url: '${NX_PUBLIC_THINK_ANALYTICS_API_BASE_URL}' + APIPath.THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED,
    },
    {
        id: 'THINK_ANALYTICS_API_GET_RELATED',
        type: 'THINK_ANALYTICS',
        feedType: 'THINK_ANALYTICS',
        url: '${NX_PUBLIC_THINK_ANALYTICS_API_BASE_URL}' + APIPath.THINK_ANALYTICS_API_GET_RELATED,
    },
    {
        id: 'THINK_ANALYTICS_API_GET_RELATED_OTHERS',
        type: 'THINK_ANALYTICS',
        feedType: 'THINK_ANALYTICS',
        url: '${NX_PUBLIC_THINK_ANALYTICS_API_BASE_URL}' + APIPath.THINK_ANALYTICS_API_GET_RELATED_OTHERS,
    },
    {
        id: 'BOOKMARK_API_WATCH_AGAIN',
        type: 'BOOKMARK',
        feedType: 'BOOKMARK',
        url: '${NX_PUBLIC_BOOKMARK_API_BASE_URL}' + APIPath.BOOKMARK_API_WATCH_AGAIN,
    },
    {
        id: 'THINK_ANALYTICS_API_SEARCH_SUGGESTIONS',
        type: 'THINK_ANALYTICS',
        feedType: 'THINK_ANALYTICS',
        url: '${NX_PUBLIC_THINK_ANALYTICS_SEARCH_API_BASE_URL}' + APIPath.THINK_ANALYTICS_API_SEARCH_SUGGESTIONS,
    },
    {
        id: 'THINK_ANALYTICS_API_SEARCH_PA',
        type: 'THINK_ANALYTICS',
        feedType: 'THINK_ANALYTICS',
        url: '${NX_PUBLIC_THINK_ANALYTICS_SEARCH_API_BASE_URL}' + APIPath.THINK_ANALYTICS_API_SEARCH_PA,
    },
    {
        id: 'CONTENT_LIKE_DISLIKE_RATING',
        type: 'LEARN_ACTION',
        feedType: 'LEARN_ACTION',
        url: '${NX_PUBLIC_LERAN_ACTION_API_BASE_URL}' + APIPath.CONTENT_LIKE_DISLIKE_RATING,
    },
    {
        id: 'SLP_COUNTRY_CONFIGS',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_COUNTRY_CONFIGS,
    },
    {
        id: 'RESUBSCRIBE_OTP_SEND',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.RESUBSCRIBE_OTP_SEND,
    },
    {
        id: 'RESUBSCRIBE_OTP_VERIFY',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.RESUBSCRIBE_OTP_VERIFY,
    },
    {
        id: 'PAYMENT_SWITCH_GENERATE',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.PAYMENT_SWITCH_GENERATE,
    },
    {
        id: 'PAYMENT_SWITCH_VERIFY',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_ENTITLEMENT_API_BASE_URL}' + APIPath.PAYMENT_SWITCH_VERIFY,
    },
    {
        id: 'RESUBSCRIBE_CREDIT_CARD',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.RESUBSCRIBE_CREDIT_CARD,
    },
    {
        id: 'SLP_BUNDLE_SAVE',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_BUNDLE_SAVE,
    },
    {
        id: 'SLP_BUNDLE_SAVE_RULES',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_BUNDLE_SAVE_RULES,
    },
    {
        id: 'bundle_and_save_rules',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_BUNDLE_SAVE_RULES,
    },
    {
        id: 'SLP_BUNDLE_SAVE_INFO',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_BUNDLE_SAVE_INFO,
    },
    {
        id: 'ACTIVE_SUB_VOUCHER',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.ACTIVE_SUB_VOUCHER,
    },
    {
        id: 'SLP_BOLT_SUBSCRIPTION',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_BOLT_SUBSCRIPTION,
    },
    {
        id: 'SLP_BOLT_SUBSCRIPTION_TWO_STEPS',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_BOLT_SUBSCRIPTION_TWO_STEPS,
    },
    {
        id: 'SLP_BOLT_VERIFICATION_TWO_STEPS',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_BOLT_VERIFICATION_TWO_STEPS,
    },
    {
        id: 'SLP_QITAF_GENERATE_OTP',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_QITAF_GENERATE_OTP,
    },
    {
        id: 'SLP_QITAF_VERIFY_OTP',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_QITAF_VERIFY_OTP,
    },
    {
        id: 'LEARN_ACTION_SET_PREFERENCES',
        type: 'LEARN_ACTIONS',
        feedType: 'LEARN_ACTIONS',
        url: '${NX_PUBLIC_LERAN_ACTION_API_BASE_URL}' + APIPath.LEARN_ACTION_SET_PREFERENCES,
    },
    {
        id: 'SEARCH_ACTION_CLICK',
        type: 'LEARN_ACTIONS',
        feedType: 'LEARN_ACTIONS',
        url: '${NX_PUBLIC_LERAN_ACTION_API_BASE_URL}' + APIPath.SEARCH_ACTION_CLICK,
    },
    {
        id: 'LEARN_EVENTS',
        type: 'LEARN_ACTIONS',
        feedType: 'LEARN_ACTIONS',
        url: '${NX_PUBLIC_LERAN_ACTION_API_BASE_URL}' + APIPath.LEARN_EVENTS,
    },
    {
        id: 'THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE',
        type: 'THINK_ANALYTICS',
        feedType: 'THINK_ANALYTICS',
        url: '${NX_PUBLIC_THINK_ANALYTICS_API_BASE_URL}' + APIPath.THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE,
    },
    {
        id: 'SLP_USER_REGISTRATION',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_USER_REGISTRATION,
    },
    {
        id: 'SLP_USER_REGISTRATION_GENERATE_PIN',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_USER_REGISTRATION_GENERATE_PIN,
    },
    {
        id: 'SLP_USER_REGISTRATION_VERIFY_PIN',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_USER_REGISTRATION_VERIFY_PIN,
    },
    {
        id: 'NOTIFICATIONS_VALIDATE_VOC_TOKEN',
        type: 'NOTIFICATION',
        feedType: 'USER_REVISION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.NOTIFICATIONS_VALIDATE_VOC_TOKEN,
    },
    {
        id: 'SLP_LEGACY_CC_MIGRATE',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_LEGACY_CC_MIGRATE,
    },
    {
        id: 'SLP_LEGACY_DCB_MIGRATE_GENERATE',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_LEGACY_DCB_MIGRATE_GENERATE,
    },
    {
        id: 'SLP_LEGACY_DCB_MIGRATE_VERIFY',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_LEGACY_DCB_MIGRATE_VERIFY,
    },
    {
        id: 'GET_PROVIDERS',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_LEGACY_DCB_MIGRATE_VERIFY,
    },
    {
        id: 'GET_FOOTER_MENU_CONTENT',
        type: 'SLP',
        feedType: 'SLP',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SLP_LEGACY_DCB_MIGRATE_VERIFY,
    },
    {
        id: 'GET_ALL_EPISODES',
        type: 'MPX',
        feedType: 'MPX',
        url: '${NX_PUBLIC_MPX_PRODUCT_FEED_BASE_URL}' + APIPath.MPX_ALL_EPISODES,
    },
    {
        id: 'GATEWAY_LANGUAGE_EN',
        type: 'GATEWAY',
        feedType: 'GATEWAY',
        url: '${NX_PUBLIC_BIG_SCREEN_API_BASE_URL}' + APIPath.GATEWAY_LANGUAGE_EN,
    },
    {
        id: 'GATEWAY_LANGUAGE_AR',
        type: 'GATEWAY',
        feedType: 'GATEWAY',
        url: '${NX_PUBLIC_BIG_SCREEN_API_BASE_URL}' + APIPath.GATEWAY_LANGUAGE_AR,
    },
    {
        id: 'MPX_BIOGRAPHY',
        type: 'MPX',
        feedType: 'MPX',
        url: '${NX_PUBLIC_MPX_BASE_URL}' + APIPath.MPX_BIOGRAPHY,
    },
    {
        id: 'LOGOUT_API',
        type: 'AUTH',
        feedType: 'AUTH',
        url: '${NX_PUBLIC_PROFILE_BASE_URL}' + APIPath.LOGOUT_API,
    },
    {
        id: 'PPV_PURCHASE',
        type: 'USER_REGISTRATION',
        feedType: 'USER_REGISTRATION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.PPV_PURCHASE,
    },
    {
        id: 'PPV_PURCHASE_GENERATE_PIN',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.PPV_PURCHASE_GENERATE_PIN,
    },
    {
        id: 'PPV_PURCHASE_VERIFY_PIN',
        type: 'ENTITLEMENT',
        feedType: 'ENTITLEMENT',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.PPV_PURCHASE_VERIFY_PIN,
    },
    {
        id: 'PPV_GET_COUNTRY_CONFIG',
        type: 'USER_REGISTRATION',
        feedType: 'USER_REGISTRATION',
        url: '${NX_PUBLIC_USER_REGISTRATION_API_BASE_URL}' + APIPath.PPV_GET_COUNTRY_CONFIG,
    },
    {
        id: 'PPV_GET_EVENT_CONFIG',
        type: 'USER_REGISTRATION',
        feedType: 'USER_REGISTRATION',
        url: '${NX_PUBLIC_USER_REGISTRATION_API_BASE_URL}' + APIPath.PPV_GET_EVENT_CONFIG,
    },
    {
        id: 'CAMPAIGN_GENERATE',
        type: 'CAMPAIGN',
        feedType: 'CAMPAIGN',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.CAMPAIGN_GENERATE,
    },
    {
        id: 'CAMPAIGN_VERIFY',
        type: 'CAMPAIGN',
        feedType: 'CAMPAIGN',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.CAMPAIGN_VERIFY,
    },
    {
        id: 'CHECK_USER',
        type: 'CAMPAIGN',
        feedType: 'CAMPAIGN',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.CHECK_USER,
    },
    {
        id: 'SUBSCRIPTION_VALIDATE_ACTIVATION_LINK',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SUBSCRIPTION_VALIDATE_ACTIVATION_LINK,
    },
    {
        id: 'SUBSCRIPTION_DISNEY_GENERATE_OTP',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SUBSCRIPTION_DISNEY_GENERATE_OTP,
    },
    {
        id: 'SUBSCRIPTION_DISNEY_VALIDATE_OTP',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SUBSCRIPTION_DISNEY_VALIDATE_OTP,
    },
    {
        id: 'SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK,
    },
    {
        id: 'SUBSCRIPTION_PARTNER_ACTIVATION_REDIRECTION',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.SUBSCRIPTION_PARTNER_ACTIVATION_REDIRECTION,
    },
    {
        id: 'FORGET_PIN_RESEND',
        type: 'USER',
        feedType: 'USER',
        url: '${NX_PUBLIC_MLP_API_BASE_URL}' + APIPath.FORGET_PIN_RESEND,
    },
];

const placeholders: Placeholder[] = [
    // Your placeholders here
    {
        key: 'NX_PUBLIC_MLP_API_BASE_URL',
        value: process.env['NX_PUBLIC_MLP_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_BOLT_API_BASE_URL',
        value: process.env['NX_PUBLIC_BOLT_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_DEVICE_API_BASE_URL',
        value: process.env['NX_PUBLIC_DEVICE_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_USER_IDENTITY_API_BASE_URL',
        value: process.env['NX_PUBLIC_USER_IDENTITY_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_ENTITLEMENT_API_BASE_URL',
        value: process.env['NX_PUBLIC_ENTITLEMENT_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_PROFILE_BASE_URL',
        value: process.env['NX_PUBLIC_PROFILE_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_PERSONA_BASE_URL',
        value: personaBaseUrl,
    },
    {
        key: 'NX_PUBLIC_ZENDESK_BASE_URL',
        value: process.env['NX_PUBLIC_ZENDESK_BASE_URL'] || '',
    },
    {
        key: 'NX_CMS_API_BASE_URL',
        value: process.env['NX_CMS_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_POPCORN_API_BASE_URL',
        value: process.env['NX_PUBLIC_POPCORN_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_USER_CDN_API_BASE_URL',
        value: process.env['NX_PUBLIC_USER_CDN_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_REMINDER_API_BASE_URL',
        value: process.env['NX_PUBLIC_REMINDER_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_BOOKMARK_API_BASE_URL',
        value: process.env['NX_PUBLIC_BOOKMARK_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_CHANNEL_CONTENT_CDN_BASE_URL',
        value: process.env['NX_PUBLIC_CHANNEL_CONTENT_CDN_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_GEO_LOCATION_API_BASE_URL',
        value: process.env['NX_PUBLIC_GEO_LOCATION_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_USER_REGISTRATION_API_BASE_URL',
        value: process.env['NX_PUBLIC_USER_REGISTRATION_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_CAROUSEL_API_BASE_URL',
        value: process.env['NX_PUBLIC_CAROUSEL_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_THINK_ANALYTICS_API_BASE_URL',
        value: process.env['NX_PUBLIC_THINK_ANALYTICS_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_LERAN_ACTION_API_BASE_URL',
        value: process.env['NX_PUBLIC_LERAN_ACTION_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_THINK_ANALYTICS_SEARCH_API_BASE_URL',
        value: process.env['NX_PUBLIC_THINK_ANALYTICS_SEARCH_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_GATEWAY_API_BASE_URL',
        value: process.env['NX_PUBLIC_GATEWAY_API_BASE_URL'] || '',
    },
    {
        key: 'NX_NOTIFICATIONS_API_BASE_URL',
        value: process.env['NX_NOTIFICATIONS_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_BIG_SCREEN_API_BASE_URL',
        value: process.env['NX_PUBLIC_BIG_SCREEN_API_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_MPX_BASE_URL',
        value: process.env['NX_PUBLIC_MPX_BASE_URL'] || '',
    },
    {
        key: 'NX_PUBLIC_MLP_BFF_INTERNAL_BASE_URL',
        value: process.env['NX_PUBLIC_MLP_BFF_INTERNAL_BASE_URL'] || '',
    },
];

const localApis = [
    {
        id: 'SLP_API_FORM_SIGNATURE',
        type: 'AUTH',
        feedType: 'AUTH',
        url: process.env['NX_PUBLIC_MLP_API_BASE_URL'] + APIPath.SLP_API_FORM_SIGNATURE,
    },
    {
        id: 'PROFILE_SWITCH',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: process.env['NX_PUBLIC_MLP_API_BASE_URL'] + APIPath.PROFILE_SWITCH,
    },
    {
        id: 'PROFILE_UPDATE',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: process.env['NX_PUBLIC_MLP_API_BASE_URL'] + APIPath.PROFILE_UPDATE,
    },
    {
        id: 'LOGOUT_API',
        type: 'AUTH',
        feedType: 'AUTH',
        url: process.env['NX_PUBLIC_MLP_API_BASE_URL'] + APIPath.LOGOUT_API,
    },
    {
        id: 'SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK',
        type: 'SUBSCRIPTION',
        feedType: 'SUBSCRIPTION',
        url: process.env['NX_PUBLIC_MLP_API_BASE_URL'] + APIPath.SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK,
    },
    {
        id: 'bundle_and_save_rules',
        type: 'SLP',
        feedType: 'SLP',
        url: process.env['NX_PUBLIC_MLP_API_BASE_URL'] + APIPath.SLP_BUNDLE_SAVE_RULES,
    },
    {
        id: 'SLP_BUNDLE_SAVE_RULES',
        type: 'SLP',
        feedType: 'SLP',
        url: process.env['NX_PUBLIC_MLP_API_BASE_URL'] + APIPath.SLP_BUNDLE_SAVE_RULES,
    },
    {
        id: 'reset_parental_lock_otp_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: personaBaseUrl + APIPath.PROFILE_RESET_PARENTAL_PIN_OTP,
    },
    {
        id: 'PROFILE_VALIDATE_PARENTAL_PIN',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: personaBaseUrl + APIPath.PROFILE_VALIDATE_PARENTAL_PIN,
    },
    {
        id: 'validate_parental_lock_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: personaBaseUrl + APIPath.PROFILE_VALIDATE_PARENTAL_PIN,
    },
    {
        id: 'PROFILE_CREATE_PARENTAL_PIN',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: personaBaseUrl + APIPath.PROFILE_CREATE_PARENTAL_PIN,
    },
    {
        id: 'create_parental_lock_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: personaBaseUrl + APIPath.PROFILE_CREATE_PARENTAL_PIN,
    },
    {
        id: 'reset_parental_lock_otp_verify_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: personaBaseUrl + APIPath.PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY,
    },
    {
        id: 'reset_parental_lock_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: process.env['NX_PUBLIC_PROFILE_BASE_URL'] + APIPath.PROFILE_UPDATE_PARENTAL_PIN,
    },
    {
        id: 'reset_parental_lock_with_otp_v1',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: personaBaseUrl + APIPath.PROFILE_RESET_PARENTAL_PIN_WITH_OTP,
    },
    {
        id: 'PROFILE_RESET_PARENTAL_PIN_WITH_OTP',
        type: 'PROFILE',
        feedType: 'PROFILE',
        url: personaBaseUrl + APIPath.PROFILE_RESET_PARENTAL_PIN_WITH_OTP,
    },
    {
        id: 'user_continue_watching',
        type: 'BOOKMARK',
        feedType: 'BOOKMARK',
        url: (process.env['NX_PUBLIC_BOOKMARK_API_BASE_URL'] || '') + APIPath.BOOKMARK_API_DETAIL,
    },
];

export const localConfig = {
    apis,
    placeholders,
    localApis,
};
